import { Flex, Radio, Text } from "@mantine/core";
import { formatPhoneNumber } from "@/shared-utils";
import type { CommunicationType } from "../types";
import { RadioButton } from "./RadioButton";
import classes from "./SendLink.module.css";

interface CommunicationTypeSelectorProps {
    commType: CommunicationType;
    setCommType: (value: CommunicationType) => void;
    form: { setFieldValue: (field: string, value: string) => void };
    email: string;
    mdn: string;
}

export const CommunicationTypeSelector = ({
    commType,
    setCommType,
    form,
    email,
    mdn,
}: CommunicationTypeSelectorProps) => (
    <Radio.Group
        value={commType}
        onChange={(value: CommunicationType) => {
            setCommType(value);
            form.setFieldValue("contact", value === "EMAIL" ? email : formatPhoneNumber(mdn).number);
        }}
    >
        <Flex direction="column" gap="md">
            <RadioButton value="SMS">
                <Text size="xs" className={classes.sendLinkOption}>
                    <strong>Send text</strong>
                </Text>
            </RadioButton>
            <RadioButton value="EMAIL">
                <Text size="xs" className={classes.sendLinkOption}>
                    <strong>Email link</strong>
                </Text>
            </RadioButton>
        </Flex>
    </Radio.Group>
);
